import React, { useEffect } from "react";
import Hero from "./Hero";
import IntroContent from "./IntroContent";
import EventsSection from "../events/EventsSection";
import { updateMetaTags } from "../../utils/metaManager";
import { pageMeta } from "../../config/helmetConfig";
import GoogleReviewBanner from "../reviews/GoogleReviewsBanner";
import "./Home.css";

export default function Home() {
  useEffect(() => {
    updateMetaTags(pageMeta.home);
  }, []);
  return (
    <div className="home-page-container">
      {/* Global brick background */}
      <div className="home-brick-background"></div>

      <div className="home-sections-container">
        <div className="home-hero-section">
          <Hero />
        </div>

        <div className="home-content-section">
          <IntroContent />
          <EventsSection />
          <GoogleReviewBanner />
        </div>
      </div>
    </div>
  );
}
